import styled from 'styled-components'

export const MigrationContent = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  padding: 24px;
  max-width: 800px;
  margin: 0 auto;
  background-color: var(--trueye-background);

  @media (min-width: 768px) {
    padding: 32px 40px;
    gap: 24px;
    max-width: 640px;
  }
`

export const PageTitle = styled.h1`
  margin: 0 0 8px;
  color: var(--trueye-white);
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  width: 100%;
`

export const SectionTitle = styled.h2`
  margin: 0 0 12px;
  color: var(--trueye-white);
  font-size: 18px;
  font-weight: 600;

  @media (min-width: 768px) {
    font-size: 20px;
  }
`

export const IntroText = styled.p`
  margin: 0;
  color: var(--trueye-light-grey-text);
  font-size: 15px;
  line-height: 1.6;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 16px;
  }
`

export const HighlightBox = styled.div`
  background: var(--trueye-dark-grey);
  border-left: 4px solid var(--trueye-accent-blue);
  padding: 16px;
  border-radius: 8px;
  width: 100%;
  display: flex;
  gap: 12px;
  align-items: flex-start;

  svg {
    color: var(--trueye-accent-blue);
    flex-shrink: 0;
    margin-top: 2px;
  }

  div {
    color: var(--trueye-light-grey-text);
    font-size: 14px;
    line-height: 1.5;
  }

  strong {
    color: var(--trueye-white);
    display: block;
    margin-bottom: 4px;
  }
`

export const UrlContainer = styled.div`
  background: var(--trueye-dark-grey);
  padding: 16px;
  border-radius: 8px;
  width: 100%;
  border: 1px solid var(--trueye-grey-border);

  @media (min-width: 768px) {
    padding: 20px 24px;
    border-radius: 12px;
  }
`

export const UrlLabel = styled.strong`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 16px;
  color: var(--trueye-white);

  svg {
    color: var(--trueye-accent-blue);
  }

  &.completed svg {
    color: #4caf50;
  }

  h2 {
    margin-bottom: 0;
  }
`

export const UrlInputGroup = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
`

export const UrlInput = styled.input`
  flex: 1;
  min-width: 200px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid var(--trueye-grey-border);
  background: var(--trueye-input-grey);
  color: var(--trueye-white);
  font-size: 14px;
  font-family: inherit;

  &:focus {
    outline: none;
    border-color: var(--trueye-accent-blue);
  }
`

export const HintText = styled.small`
  display: block;
  margin-top: 8px;
  color: var(--trueye-text-grey);
  font-size: 12px;
  line-height: 1.4;
`

export const InstructionsContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
`

export const TabsContainer = styled.div`
  display: flex;
  width: 100%;

  .C-ButtonGroup {
    flex-grow: 1;
  }

  .C-ButtonGroup__ListItem {
    flex-basis: 0;
    flex-grow: 1;
  }

  .C-Button {
    background: var(--trueye-secondary-main-color);
    border: none;
    border-radius: 8px 8px 0 0 !important;
    color: var(--trueye-text-grey);
    padding: 12px;
    width: 100%;
    font-weight: 500;

    &:hover {
      background: var(--trueye-alternate-main-grey);
    }

    &.selected-tab {
      background: var(--trueye-dark-grey);
      border-bottom: 2px solid var(--trueye-accent-blue);
      color: var(--trueye-white);
    }
  }
`

export const InstructionCard = styled.div`
  width: 100%;
  background: var(--trueye-dark-grey);
  padding: 20px;
  border-radius: 0 0 8px 8px;
  border: 1px solid var(--trueye-grey-border);
  border-top: none;
`

export const InstructionTitle = styled.h3`
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
  color: var(--trueye-white);
`

export const InstructionList = styled.ol`
  margin: 0;
  padding-left: 0;
  color: var(--trueye-light-grey-text);
  line-height: 1.6;
  font-size: 14px;
  list-style: none;
  p {
    color: var(--trueye-light-grey-text);
  }

  li {
    margin-bottom: 12px;
    display: flex;
    gap: 12px;
    align-items: flex-start;

    &:last-child {
      margin-bottom: 0;
    }

    strong {
      color: var(--trueye-white);
    }
  }
`

export const StepNumber = styled.span`
  background: var(--trueye-accent-blue);
  color: var(--trueye-white);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 13px;
  flex-shrink: 0;
`

export const FooterInfo = styled.div`
  width: 100%;
  color: var(--trueye-text-grey);
  font-size: 14px;
  line-height: 1.5;

  p {
    margin: 0 0 8px;

    &:last-child {
      margin: 0;
    }
  }

  strong {
    font-weight: 600;
    color: var(--trueye-white);
  }

  a {
    color: var(--trueye-accent-blue);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      color: var(--trueye-blue);
    }
  }
`

export const BenefitsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`

export const BenefitItem = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;

  svg {
    color: var(--trueye-accent-blue);
    flex-shrink: 0;
    margin-top: 2px;
  }

  div {
    color: var(--trueye-light-grey-text);
    font-size: 14px;
    line-height: 1.5;
  }

  strong {
    color: var(--trueye-white);
    font-weight: 600;
  }

  @media (min-width: 768px) {
    div {
      font-size: 15px;
    }
  }
`

export const CompletionNote = styled(HintText)`
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--trueye-grey-border);
  display: flex;
  align-items: center;
  gap: 8px;
`

export const AppIcon = styled.img`
  width: 24px;
  height: 24px;
  vertical-align: middle;
  margin-right: 6px;
  border-radius: 4px;
`

export const OpenInBrowserLink = styled.a`
  display: block;
  padding: 8px;
  background: var(--trueye-accent-blue);
  border: 2px solid var(--trueye-accent-blue);
  border-radius: 8px;
  color: var(--trueye-white);
  text-decoration: none;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;

  &:hover {
    background: var(--trueye-blue);
    border-color: var(--trueye-blue);
  }

  @media (min-width: 768px) {
    display: inline-block;
    padding: 12px 32px;
    font-size: 15px;
    border-radius: 10px;
  }
`

export const CollapsibleDetails = styled.details`
  margin-top: 12px;

  summary {
    color: var(--trueye-text-grey);
    cursor: pointer;
    font-size: 14px;
  }
`

export const CenteredHintText = styled(HintText)`
  text-align: center;
`

export const HighlightBoxSpaced = styled(HighlightBox)`
  margin-top: 24px;
`

export const InstructionIntro = styled(IntroText)`
  margin-bottom: 12px;
`

export const SupportText = styled(HintText)`
  margin: 16px 0;
  text-align: center;
`

export const SunsetWarningBox = styled(HighlightBox)`
  border-left-color: #f57c00;
  margin-top: 4px;

  svg {
    color: #f57c00;
  }
`

export const MdmNoticeBox = styled(HighlightBox)`
  border-left-color: #4caf50;

  svg {
    color: #4caf50;
  }
`

export const ManualFallbackDetails = styled.details`
  margin-top: 16px;
  width: 100%;

  summary {
    color: var(--trueye-accent-blue);
    cursor: pointer;
    font-size: 13px;
    user-select: none;

    &:hover {
      text-decoration: underline;
    }
  }
`

export const BookmarkHero = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 8px;
  text-align: center;
  width: 100%;

  @media (min-width: 768px) {
    gap: 12px;
    padding-top: 16px;
  }
`

export const BookmarkEmojiIcon = styled.span`
  font-size: 48px;
  line-height: 1;

  @media (min-width: 768px) {
    font-size: 64px;
  }
`
